/* eslint-disable global-require */

export default {
  data() {
    return {
      isShowPassword: false,
    };
  },
  computed: {
    passwordType() {
      return this.isShowPassword ? 'text' : 'password';
    },
    passwordIcon() {
      return this.isShowPassword
        ? require('dashboard/assets/icons/eye-icon.svg')
        : require('dashboard/assets/icons/eye-slash-icon.svg');
    },
  },
  methods: {
    onTogglePasswordType() {
      this.isShowPassword = !this.isShowPassword;
    },
  },
};
